import React, { Component } from 'react'
import './index.css'

export default class Tag extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`tag-component ${this.props.variant || 'warning'} ${this.props.noPoint && 'no-point'}`}>
        {this.props.text}
      </div>
    )
  }
}

